import str from "@/utils/str";

export const props = {
  // 賽事名稱
  name: {
    type: String,
    required: true,
  },
  event: {
    type: String,
    required: true,
  },
  game_time: {
    type: String,
    required: true,
  },
  reward: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
};

export default {
  data() {
    return {
      searchData: {},
    };
  },
  created() {
    if (!this.hasParams) {
      this.$router.push({ name: "tg_business.reward-record" });
    }
  },
  mounted() {
    this.addBreadcrumb();
  },
  computed: {
    hasParams() {
      return this.$history.exist(this.historyKey);
    },
    params() {
      return this.$history.get(this.historyKey);
    },
  },
  methods: {
    handleSearch(searchHandler) {
      searchHandler(this.searchData);
    },
    addBreadcrumb() {
      this.$store.commit("breadcrumb/add", {
        name: "tg_business.reward-record.member",
        query: {
          ...this.$route.query,
          h: this.historyKey,
        },
        path: this.$route.path,
        meta: {
          title: str.format(
            "[{0}] {1} {2}",
            this.params.title,
            this.params.game_time,
            this.params.game_name
          ),
        },
      });
    },
  },
};
